'use strict'

var config, service, email;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  email = config.VUE_APP_MOL_S_EMAIL
}

async function inviaEmail(destinatario, copiaCarbone, infoEmail, allegati) {
  if (!config || !service) {
    await getConfigFile();
  }
  const msg = {
    to: destinatario,
    cc: copiaCarbone,
    from: infoEmail.mittente,
    subject: infoEmail.oggetto,
    text: infoEmail.messaggio,
    html: infoEmail.messaggioHtml
  }

  const data = {
    messaggio: msg,
    allegati
  }
  try {
    const response = await fetch(`${service}/${email}${infoEmail.templateId ? '/' + infoEmail.templateId : '' }`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
    return []
  }
}

export default {
  inviaEmail
}
